import { Suspense } from "react"
import { useTranslation } from "react-i18next"
import { Await, Outlet, ScrollRestoration, useLoaderData, useLocation } from "react-router"
import { PwaInstall } from "@cividao/components"
import { RootLoaderData } from "../../../pages/Root/loader"
import { Loading } from "../Layout/Loading"
import { LOGO, PWA_HIDDEN_ROUTES } from "../../../js/const"

export function RootTemplate() {
  const { projectConfigPromise } = useLoaderData() as RootLoaderData
  const { t } = useTranslation("pwa")
  const { pathname } = useLocation()
  const showPwaInstall = !PWA_HIDDEN_ROUTES.has(pathname)

  return (
    <>
      <Suspense fallback={<Loading />}>
        <Await resolve={projectConfigPromise}>{() => <Outlet />}</Await>
      </Suspense>
      <ScrollRestoration />
      <PwaInstall
        isVisible={showPwaInstall}
        appName={t("appName")}
        appUrl={window.location.origin}
        appIcon={LOGO}
        appLogo={LOGO}
        ratingCount={5}
        literals={{
          notificationText: t("notificationText"),
          buttonText: t("buttonText"),
          installQuestion: t("installQuestion"),
          tapToInstall: t("tapToInstall"),
          incompatibleBrowserTitle: t("incompatibleBrowserTitle"),
          incompatibleBrowserMessage: t("incompatibleBrowserMessage"),
          incompatibleBrowserCopyLink: t("incompatibleBrowserCopyLink"),
          incompatibleBrowserLinkCopied: t("incompatibleBrowserLinkCopied"),
          iosStep1: t("iosStep1"),
          iosStep2: t("iosStep2"),
          shareText: t("shareText"),
          moreText: t("moreText"),
          addToHomeScreenText: t("addToHomeScreenText"),
          iosStep3: t("iosStep3"),
        }}
        showAlways
      />
    </>
  )
}
